<script setup lang="ts">
import { PropType } from "vue";
import { FeedbackChoiceOption } from "@/components/Core/PopupMessages/Feedback/feedbackSurvey";

defineProps({
  options: { type: Array as PropType<FeedbackChoiceOption[]>, required: true },
  selected: { type: String, default: undefined },
  inline: { type: Boolean, default: false },
  labelledby: { type: String, required: true },
});
const emit = defineEmits({ select: (_value: string) => true });
</script>

<template>
  <div
    role="group"
    :aria-labelledby="labelledby"
    class="flex gap-1.5"
    :class="inline ? 'flex-row' : 'flex-col'"
  >
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      :aria-pressed="selected === option.value"
      class="flex flex-1 items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium text-gray-800 ring-1 ring-gray-200 transition-colors ring-inset hover:bg-purple-50 hover:ring-purple-300 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-700 aria-pressed:bg-purple-50 aria-pressed:text-purple-800 aria-pressed:ring-purple-700"
      :class="inline ? 'justify-center' : 'text-left'"
      @click="emit('select', option.value)"
    >
      {{ option.label }}
    </button>
  </div>
</template>
